import { StaticValues } from '@utils/enums/StaticValues.enum';
import type { FieldStatus } from '@utils/interfaces';
import { t } from 'i18next';
import * as yup from 'yup';

export const calendarInsuranceFormSchema = (
  insurancePlanStatus?: FieldStatus,
  insuranceIdStatus?: FieldStatus,
) => {
  const insurancePlanVisible =
    insurancePlanStatus !== StaticValues.FIELD_STATUS_HIDDEN;
  const insurancePlanRequired =
    insurancePlanVisible &&
    insurancePlanStatus !== StaticValues.FIELD_STATUS_OPTIONAL;
  const insuranceIdRequired =
    insurancePlanVisible &&
    insuranceIdStatus !== StaticValues.FIELD_STATUS_HIDDEN &&
    insuranceIdStatus !== StaticValues.FIELD_STATUS_OPTIONAL;
  const requiredError = t('fieldsLabel.errors.isRequired');
  const maxLengthError = t('fieldsLabel.errors.maxLength', { max: 255 });

  return yup.object().shape({
    insurance: yup.object().shape({
      plan: yup.string().when([], {
        is: () => insurancePlanRequired,
        then: schema => schema.required(requiredError), // NOSONAR
        otherwise: schema => schema.notRequired(),
      }),
      id: yup.string().when('plan', {
        is: (plan: string) => plan === StaticValues.YES && insuranceIdRequired,
        then: schema => schema.required(requiredError), // NOSONAR
        otherwise: schema => schema.notRequired(),
      }),
      other: yup.string().when(['plan', 'id'], {
        is: (plan: string, id: string) =>
          plan === StaticValues.YES &&
          id === StaticValues.OTHER_OPTION &&
          insuranceIdRequired,
        then: schema => schema.required(requiredError).max(255, maxLengthError), // NOSONAR
        otherwise: schema => schema.notRequired(),
      }),
    }),
  });
};
